export const RELOAD_SAVED_FILTERS = Symbol('Reload saved filters');
